import { delegate } from "tippy.js";

function initializeTooltips(): void {
  const container = document.getElementById("datatable");
  if (!container) return;

  delegate(container, {
    target: "[data-tooltip]",
    content(reference) {
      return reference.getAttribute("data-tooltip") || "";
    },
    allowHTML: false,
    appendTo: () => document.body,
    arrow: false,
    delay: 0,
    duration: [80, 60],
    maxWidth: 360,
    offset: [0, 8],
    placement: "bottom-end",
    theme: "rdfvisualizer",
    popperOptions: {
      modifiers: [
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top-end", "bottom-start", "top-start"]
          }
        },
        {
          name: "preventOverflow",
          options: { padding: 12 }
        }
      ]
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeTooltips, { once: true });
} else {
  initializeTooltips();
}
